/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodConnectionActivityStateDto } from './PaymentMethodConnectionActivityStateDto';
import {
    PaymentMethodConnectionActivityStateDtoFromJSON,
    PaymentMethodConnectionActivityStateDtoFromJSONTyped,
    PaymentMethodConnectionActivityStateDtoToJSON,
    PaymentMethodConnectionActivityStateDtoToJSONTyped,
} from './PaymentMethodConnectionActivityStateDto';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';

/**
 * 
 * @export
 * @interface PaymentMethodCountryDto
 */
export interface PaymentMethodCountryDto {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodCountryDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {CountryCode}
     * @memberof PaymentMethodCountryDto
     */
    countryCode: CountryCode;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCountryDto
     */
    paymentsEnabled: boolean;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof PaymentMethodCountryDto
     */
    defaultEnabledInApps: Set<FavritApp>;
    /**
     * 
     * @type {PaymentMethodConnectionActivityStateDto}
     * @memberof PaymentMethodCountryDto
     */
    activityState: PaymentMethodConnectionActivityStateDto;
}



/**
 * Check if a given object implements the PaymentMethodCountryDto interface.
 */
export function instanceOfPaymentMethodCountryDto(value: object): value is PaymentMethodCountryDto {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('paymentsEnabled' in value) || value['paymentsEnabled'] === undefined) return false;
    if (!('defaultEnabledInApps' in value) || value['defaultEnabledInApps'] === undefined) return false;
    if (!('activityState' in value) || value['activityState'] === undefined) return false;
    return true;
}

export function PaymentMethodCountryDtoFromJSON(json: any): PaymentMethodCountryDto {
    return PaymentMethodCountryDtoFromJSONTyped(json, false);
}

export function PaymentMethodCountryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodCountryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'countryCode': CountryCodeFromJSON(json['countryCode']),
        'paymentsEnabled': json['paymentsEnabled'],
        'defaultEnabledInApps': (new Set((json['defaultEnabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'activityState': PaymentMethodConnectionActivityStateDtoFromJSON(json['activityState']),
    };
}

export function PaymentMethodCountryDtoToJSON(json: any): PaymentMethodCountryDto {
    return PaymentMethodCountryDtoToJSONTyped(json, false);
}

export function PaymentMethodCountryDtoToJSONTyped(value?: PaymentMethodCountryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'countryCode': CountryCodeToJSON(value['countryCode']),
        'paymentsEnabled': value['paymentsEnabled'],
        'defaultEnabledInApps': (Array.from(value['defaultEnabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'activityState': PaymentMethodConnectionActivityStateDtoToJSON(value['activityState']),
    };
}

